/*
 * File: Account.tsx
 * Project: a-a
 * File Created: Saturday, 9th November 2024 9:48:32 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 16th April 2026 9:11:41 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import InfiniteScrollColumn from '../../InfiniteScrollColumn/InfiniteScrollColumn';
import { Box, Typography } from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import CustomCard from '../../CustomCard/CustomCard';
import AccountCard from './AccountCard/AccountCard';
import { DashboardService } from '../../../../service/dashboard.service';
import styles from './AccountColumn.module.css';
const AccountColumn = ({
  setTabLoading,
  path,
}: {
  setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
  path?: string;
}) => {
  const screenHeight = window.innerHeight;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<{ accounts: any[] }>({ accounts: [] });
  const getAccount = async () => {
    setLoading(true);
    try {
      //  const toolsQuery = selectedItems.tools.join(',');
      //  const timeQuery = selectedItems.time
      //    .map((val: string) => 'this' + val.toLocaleLowerCase())
      //    .join(',');

      const res = await DashboardService.getActionAccount();
      if (res) {
        setData({ ...res });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setTabLoading(false);
    }
  };
  // console.log(data);
  useEffect(() => {
    getAccount();
  }, []);
  const Header = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: { xs: '34px', xl: '48px' },
        }}
      >
        <Typography variant='responsiveHeading3'>Actionable Accounts</Typography>
      </Box>
    );
  };
  const Column = () => {
    return !data?.accounts?.length && !loading ? (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: { xs: '24vh', xl: '30vh' },
        }}
      >
        {' '}
        <img src={'/assets/no-action-account.svg'} className={styles['no-account-icon']} />
        <Typography
          variant='responsiveHeading3'
          color={zeplinColor.BasicBlack}
          sx={{ marginTop: { xs: '22px', xl: '24px' } }}
        >
          No Actionable Accounts
        </Typography>
        <Typography
          variant='responsiveBody3'
          color={zeplinColor.Neutral8}
          sx={{ marginTop: { xs: '10px', xl: '12px' }, textAlign: 'center' }}
        >
          Great work! There’s nothing that needs your attention right now. Keep up the momentum!
        </Typography>
      </Box>
    ) : loading ? (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: { xs: '24vh', xl: '30vh' },
          overflowY: 'hidden',
          gap: { xs: '10px', xl: '16px' },
        }}
      >
        {[1, 2, 3, 4, 5].map((val: any, ind: number) => (
          <AccountCard data={val} index={ind} key={ind} loading={true} />
        ))}
      </Box>
    ) : (
      <Box
        sx={{
          overflowY: 'scroll',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          position: 'relative',
          // height: screenHeight > 640 ? '25vh' : screenHeight > 500 ? '12vh' : '10vh',
          height: { xs: 'calc(100vh - 660px)', xl: 'calc(100vh - 750px)' },

          gap: { xs: '10px', xl: '16px' },
        }}
      >
        {data?.accounts?.map((val: any, ind: number) => (
          <AccountCard data={val} index={ind} key={ind} path={path || ''} />
        ))}
      </Box>
    );
    // </Box>
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '0px',
        padding: '10px 16px 16px 16px',

        border: `1px solid ${zeplinColor.Neutral5}`,
        borderRadius: '14px',
      }}
    >
      <Header />
      <Column />
    </Box>
  );
};

export default AccountColumn;
